"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExportColumnsViewItems = void 0;
const getExportColumnsViewItems = (report, api) => {
    return {
        name: 'Columns',
        values: [...api.internalApi.getReportService().GetReportColumnScopeShortDescription(report)],
    };
};
exports.getExportColumnsViewItems = getExportColumnsViewItems;
